import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

/**
 * Captures the poster DOM (exact pixel size) and builds a single-page PDF.
 * Opens it in a new tab when allowed; otherwise triggers download.
 */
export async function exportPosterElementToPdf(element, fileName) {
  if (!element || !(element instanceof HTMLElement)) {
    throw new Error("No se encontro el lienzo del cartel.");
  }

  const w = Math.max(1, Math.round(element.offsetWidth));
  const h = Math.max(1, Math.round(element.offsetHeight));

  const maxEdge = 3200;
  const scale = Math.min(2, maxEdge / Math.max(w, h));

  const canvas = await html2canvas(element, {
    scale,
    useCORS: true,
    allowTaint: false,
    backgroundColor: "#ffffff",
    width: w,
    height: h,
    windowWidth: w,
    windowHeight: h,
    logging: false,
    scrollX: 0,
    scrollY: 0,
  });

  const iw = canvas.width;
  const ih = canvas.height;
  let imgData;
  try {
    imgData = canvas.toDataURL("image/jpeg", 0.92);
  } catch (e) {
    throw new Error(
      "No se pudo exportar (posible bloqueo CORS en alguna imagen externa). Prueba sin QR o con imagenes solo del torneo."
    );
  }

  const pdf = new jsPDF({
    orientation: iw >= ih ? "landscape" : "portrait",
    unit: "px",
    format: [iw, ih],
    hotfixes: ["px_scaling"],
    compress: true,
  });

  pdf.addImage(imgData, "JPEG", 0, 0, iw, ih, undefined, "FAST");

  const blob = pdf.output("blob");
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) {
    pdf.save(fileName);
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 120_000);
}

export function buildPosterPdfFileName(tournamentName, tournamentId) {
  const safe =
    String(tournamentName || "torneo")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^\w\s-]/g, "")
      .trim()
      .replace(/\s+/g, "-")
      .slice(0, 48) || "torneo";
  const idPart = String(tournamentId || "").replace(/-/g, "").slice(0, 8);
  return `cartel-${safe}${idPart ? `-${idPart}` : ""}.pdf`;
}
